import { lazy } from 'react'
import {
  createRoutesFromElements,
  createBrowserRouter,
  Route,
  Navigate,
} from 'react-router-dom'
import { pageUrl } from '@/constants/url'
import { AuthLayout } from '../components/layout/auth'
import { PrivateRoute } from './privateRoute'
import { onboardingRoutes } from '@/modules/onboarding/routes'
import { teamRoutes } from '@/modules/teams/routes'
import { branchRoutes } from '@/modules/branch/routes'
import { calendarRoutes } from '@/modules/calendar/routes'
import { errorsRoutes } from '@/modules/errors/routes'
import { authRoutesPublic, authRoutesAdmin } from '@/modules/auth/routes'
import { clientsRoutes } from '@/modules/clients/routes'
import { salesRoutes, salesPublicRoutes } from '@/modules/sales/routes'
import { settingsRoutes } from '@/modules/settings/routes'
import { reportRoutes } from '@/modules/reports/routes'
import { accountRoutes } from '@/modules/account/routes'
import {
  engagementsPrivateRoutes,
  engagementsPublicRoutes,
} from '@/modules/engagement/routes'
import { billingRoutes } from '@/modules/billings/routes'
import { catalogRoutes } from '@/modules/catalog/routes'
import { notificationsRoutes } from '@/modules/notifications/routes'
import { ErrorPageRouter } from './errorPageRouter'
import { paymentsRoutes } from '@/modules/payments/routes'
import { expensesRoutes } from '@/modules/expenses/routes'
import { leaveRoutes } from '@/modules/leave/routes'

const HomePage = lazy(() => import('@/modules/home'))

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        path={pageUrl.main}
        element={<Navigate to={pageUrl.branch} replace />}
      />
      {/* private route */}
      <Route errorElement={<ErrorPageRouter />} element={<PrivateRoute />}>
        {/* private with layout */}
        <Route element={<AuthLayout />}>
          <Route path={pageUrl.home} element={<HomePage />} />
          {teamRoutes()}
          {branchRoutes()}
          {calendarRoutes()}
          {authRoutesAdmin()}
          {clientsRoutes()}
          {salesRoutes()}
          {settingsRoutes()}
          {leaveRoutes()}
          {reportRoutes()}
          {accountRoutes()}
          {engagementsPrivateRoutes()}
          {billingRoutes()}
          {catalogRoutes()}
          {notificationsRoutes()}
          {paymentsRoutes()}
          {expensesRoutes()}
        </Route>
        {/* private without layout */}
        {onboardingRoutes()}
      </Route>
      {/* public route */}
      {engagementsPublicRoutes()}
      {salesPublicRoutes()}
      {authRoutesPublic()}
      {errorsRoutes()}
    </>,
  ),
)
